import * as Yup from 'yup';
import { useTranslation } from '@shared/core';

export const createPlaceToStayValidationSchema = (tq: ReturnType<typeof useTranslation>['tq']) => {
  return Yup.object({
    address: Yup.string()
      .required(tq`Please add an address`)
      .test('location-selected', tq`Please select an address from the dropdown`, function (value) {
        const { latitude, longitude } = this.parent;
        if (!value) return true;
        const lat = Number(latitude);
        const lng = Number(longitude);
        const hasValidCoords = !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;
        return hasValidCoords;
      }),
    customName: Yup.string().when('joyPlaceId', {
      is: (val: string | null | undefined) => !val,
      then: (schema: Yup.StringSchema) => schema.required(tq`Please search for a hotel`),
      otherwise: (schema: Yup.StringSchema) => schema.nullable(),
    }),
    customUrl: Yup.string()
      .nullable()
      .trim()
      .url(tq`Please enter a valid URL.`),
  });
};
